// extracted by mini-css-extract-plugin
export default {"iconColumn":"iconColumn---G7Qh0"};